import { render, staticRenderFns } from "./ServiceDialog.vue?vue&type=template&id=0983b706&scoped=true&"
import script from "./ServiceDialog.vue?vue&type=script&lang=js&"
export * from "./ServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDialog.vue?vue&type=style&index=0&id=0983b706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983b706",
  null
  
)

export default component.exports